import BarChart from 'modules/Drive/Partials/ViewReportDrawer/Style/BarChart'
import DoughtChart from 'modules/Drive/Partials/ViewReportDrawer/Style/Chart'
import {
  BarContainer, BoldHeading, ColContainer, RowContainer, StyledDrawer
} from 'modules/Drive/Partials/ViewReportDrawer/Style/style'
import React from 'react'

const ViewReportDrawer = ({ viewReportDrawer, setViewReportDrawer }) => {
  const content = () => {
    return (
      <RowContainer>
        <BarContainer span={23}>
          <BoldHeading>Applied Student Stats</BoldHeading>
          <BarChart />
        </BarContainer>
        <ColContainer span={11}>
          <BoldHeading>Application Status</BoldHeading>
          <DoughtChart
            labels={[
              'Total Apllied',
              'Shortlisted',
              'Rejected',
              'Offer Received',
            ]}
            chartData={[976, 465, 509, 40]}
          />
        </ColContainer>
        <ColContainer span={11}>
          <BoldHeading>Offer Status</BoldHeading>
          <DoughtChart
            labels={[
              'Total Apllied',
              'Shortlisted',
              'Rejected',
              'Offer Received',
            ]}
            chartData={[30, 45, 10, 40]}
          />
        </ColContainer>
      </RowContainer>
    )
  }

  return (
    <StyledDrawer
      title={<h3>View Report</h3>}
      placement="right"
      closable={true}
      onClose={() => {
        setViewReportDrawer(false)
      }}
      visible={viewReportDrawer}
      content={content()}
      width="80%"
    />
  )
}

export default ViewReportDrawer
